module.exports = __webpack_public_path__ + "static/media/Large_2015.2a6fcc3e.svg";